// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","697":"news","893":"products"}[chunkId] + "." + {"443":"29a8cd53","697":"b4461652","893":"149d7264"}[chunkId] + ".js";
};